<template>
    <div id="auth">
        <el-form :model="inputForm" :rules="validationRule" ref="inputForm" label-width="0px" @submit.native.prevent="login">
            <div class="console-logo">
                <div class="console-logo-icon"><img :src="require('@/assets/logo_buddycom_color.svg')"/></div>
                <div class="console-logo-text">Partner Console</div>
            </div>
            <el-form-item prop="loginId">
                <el-input class="el-inputid" size="large" type="text" @input.native="checkNullInput(0)" v-model="inputForm.loginId" placeholder="ログインID"/>
            </el-form-item>
            <el-form-item prop="password">
                <el-input class="el-inputlock" size="large" type="password" @input.native="checkNullInput(1)" v-model="inputForm.password" placeholder="パスワード"/>
            </el-form-item>
            <!---el-select class="el-inputlang" v-model="selectedLanguage">
                <el-option v-for="lang in languages"
                    :key="lang.value"
                    :label="lang.label"
                    :value="lang.value"
                    :disabled="lang.disabled">
                </el-option>
            </el-select--->
            <el-button type="primary" :disabled="this.$data.disableButton" native-type="submit">ログインする</el-button>
        </el-form>
    </div>
</template>

<script>
import server from "./components/PartnerServerApi.js";
import VueCookie from "vue-cookie";
import charactercheck from './components/charactercheck.js';
import constants from './components/constants.js';

export default {
    name: 'auth',
    data() {
        var validateLoginID = (rule, value, callback) => {
            if (!charactercheck.isValidForMailaddress(value)) {
                callback(new Error('ログインIDの形式が間違っています。'))
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (!charactercheck.isValidForPassword(value)) {
                callback(new Error('パスワードの形式が間違っています。'))
            } else {
                callback();
            }
        };
        return {
            selectedLanguage: "Japanese",
            disableButton: true,
            nullInput: [ true ,true ],
            icon: {
                id: null,
                password: null,
                lock: null,
                lang: null
            },
            languages: [
                { value: 'Japanese', label: '日本語' , disabled: false } ,
                { value: 'English', label: 'English' , disabled: false }
            ],
            inputForm: {
                loginId: '',
                password: ''
            },
            validationRule: {
                loginId: [
                    { validator: validateLoginID, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        login: function (event) {
            let savethis = this;
            let id = savethis.$data.inputForm.loginId;
            let password = savethis.$data.inputForm.password;
            this.$refs["inputForm"].validate((valid) => {
                if (!valid) {
                    return false;
                }
                server.postNoError('/login', {id: id, password: password})
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        sessionStorage.setItem('partner-loginId', savethis.inputForm.loginId);
                        sessionStorage.setItem('token', res.data.token);
                        window.location.href = "/static/partner.html";
                    } else {
                        savethis.$message.error('ログインに失敗しました。ユーザーIDまたは、パスワードを確認してください。');
                    }
                })
                .catch( function ( error ) {
                    savethis.$message.error('ログインに失敗しました。ユーザーIDまたは、パスワードを確認してください。');
                });
            });
        },
        checkNullInput: function(index) {
            switch(index) {
                case 0:
                    if ((this.$data.inputForm.loginId == null) ||
                        (this.$data.inputForm.loginId == "")) {
                        this.$data.nullInput[0] = true;
                    } else {
                        this.$data.nullInput[0] = false;
                    }
                    break;
                case 1:
                    if ((this.$data.inputForm.password == null) ||
                        (this.$data.inputForm.password == "")) {
                        this.$data.nullInput[1] = true;
                    } else {
                        this.$data.nullInput[1] = false;
                    }
                    break;
            }
            for (let i = 0 ; i < this.$data.nullInput.length ; i++) {
                if (this.$data.nullInput[i]) {
                    this.$data.disableButton = true;
                    return;
                }
            }
            this.$data.disableButton = false;
        },
        handleIconClick: function(event) {
            console,log("handleIconClick",event);
        }
    },
    created: function() {
        this.checkNullInput();
    }
}
</script>

<style>
    .el-inputid > .el-input__inner {
        background-image:url('./assets/icon_id.svg');
     }
    .el-inputlock > .el-input__inner {
        background-image:url('./assets/icon_lock.svg');
     }

    .el-input__inner {
        background-repeat:no-repeat;
        color: #000000;
        height: 50px;
        padding-left: 36px;
        background-position-x: 10px;
        background-position-y: center;
        background-size: 20px 20px;
    }

    .el-select .el-input__inner {
        background-image:url('./assets/icon_region.svg');
        background-repeat:no-repeat;
        color: #000000;
        height: 50px;
        background-position-x: 10px;
        background-position-y: center;
        background-size: 20px 20px;
    }

    .el-select-dropdown__item.selected {
        color: #000000;
    }

    .el-select-dropdown__item {
        text-align: left;
    }

    .el-form-item__error {
        color: #d55169;
        margin-left: 50px;
        padding-top: 8px;
    }

    .el-form-item.is-error {
        margin-bottom: 30px;;
    }

    .el-form-item.is-error .el-input__inner {
        border-color:#d55169;
    }

    .el-form-item.is-success {
        margin-bottom: 22px;;
    }

    .el-form-item.is-success .el-input__inner,
    .el-form-item.is-success .el-input__inner:focus,
    .el-form-item.is-error .el-input__inner:focus {
        border-color:#c1c4c8;
    }

    .el-form-item .el-input__inner:focus {
        border-color:#5171cb;
    }

    .el-form {
        width: 400px;
        margin:70px auto;
        text-align:center;
        padding:40px;
    }

    .el-input {
        left: 0;
        top: 0;
        caret-color: #5171cb;
        color: #000000;
        width: 300px;
    }

    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
        opacity: 0.3;
        background-color: #5171cb;
    }

    .el-button--primary:hover {
        opacity: 0.8;
    }

    .el-message--error .el-message__content {
        color: #d55169;
    }

</style>

<style scoped>
    html {
        margin: 0;
    }

    body {
        background: #ecf1fa;
        margin: 0;
    }

    a {
        color: #5171cb;
        font-style: normal;
        text-decoration: none;
    }
    a:link {
        color: #5171cb;
        font-style: normal;
        text-decoration: none;
    }
    a:visited {
        color: #5171cb;
        text-decoration: none;
    }

    .aldiologo {
        height: 48px;
        padding: 32px;
    }

    .el-button {
        position: relative;
        display: block;
        margin: 22px auto;
        padding: 17px;
        width: 300px;
        font-size: 12px;
        color: #fff;
        background-color: #5171cb;
        cursor: pointer;
    }

    .console-logo {
        height: 36px;
        padding-bottom: 32px;
        text-align: center;
        display: inline-block;
    }
    .console-logo-icon {
        float: left;
    }
    .console-logo-icon img {
        height: 36px;
        padding-right: 5px;
    }
    .console-logo-text {
        font-size: 16px;
        font-weight: 700;
        float: left;
        margin-top: 10px;
        margin-left: 8px;
    }

</style>
